<template>
  <div class="full-height fba-container-order">
    <full-con :canReturn="canReturn">
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/FBA/' }">FBA</el-breadcrumb-item>
        <el-breadcrumb-item>新建装箱单</el-breadcrumb-item>
      </el-breadcrumb> -->
      <!-- <div slot="search" style="text-align: right">
      </div> -->
      <div slot="editBreadcrumb">
        <editBreadcrumb :pageTitle="pageTitle"></editBreadcrumb>
      </div>
      <!-- 内容 -->
      <div slot="full" class="full-height display-col create-fba-content" style="position: relative">
        <el-row class="search-btn-container" style="padding-bottom: 10px">
          <el-button type="primary" class="search-btn btn-green" @click="newBuiltGoods">{{$t('fba.addGoods')}}</el-button>
          <el-upload style="display: inline-block" action="#" :auto-upload="false" :on-change="handleFileSelect" accept=".xls,.xlsx" :show-file-list="false">
            <el-button type="primary" class="search-btn btn-blue">{{$t('FBAContainerOrder.FBAContainerOrder9')}}</el-button>
          </el-upload>
        </el-row>
        <el-table :data="SelectedGoodsList" border stripe style="width: 100%; overflow: auto" height="550" :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle">
          <el-table-column type="index" :label="$t('wzbg.wz6')" width="50" align="center"></el-table-column>
          <el-table-column align="center" prop="id" :label="$t('fba.orderNo')" width="70"></el-table-column>
<!--          <el-table-column align="center" prop="userName" :label="$t('createOrder.createOrder102')" width="70"> </el-table-column>-->
          <el-table-column align="center" prop="clientManagerUserName" :label="$t('cnumber.cnumber30')" width="70"> </el-table-column>
          <el-table-column prop="goodsName" :label="$t('fba.goodsName')" min-width="250" align="center" width="250">
          </el-table-column>
          <el-table-column prop="pictureUrl" :label="$t('OrderDetail.OrderDetail54')" min-width="250" align="center" width="250">
            <template slot-scope="scope">
              <img :src="scope.row.pictureUrl" @click="imgclick(scope.row.pictureUrl,true)" width="180" height="320" class="head_pic" />
            </template>
          </el-table-column>
          <el-table-column prop="orderType" label="FBA YFF/ZOZO/RSL/ストッククルー" align="center">
            <template v-slot="scope">
              <span v-if="scope.row.orderType == 0">FBA</span>
              <span v-if="scope.row.orderType == 1">{{$t('filter.filter36')}}</span>
              <span v-if="scope.row.orderType == 2">YFF</span>
              <span v-if="scope.row.orderType == 3">ZOZO</span>
              <span v-if="scope.row.orderType == 4">RSL</span>
              <span v-if="scope.row.orderType == 5">ストッククルー</span>
            </template>
          </el-table-column>
          <el-table-column prop="fnsku" label="FNSKU" align="center"></el-table-column>
          <el-table-column prop="goodsNameCus" :label="$t('OrderDetail.OrderDetail55')" align="center">
            <template v-slot="scope">
              <el-input type="textarea" placeholder="" v-model="scope.row.goodsNameCus" size="small" disabled>
              </el-input>
            </template>
          </el-table-column>

          <el-table-column prop="orderStatus" align="center" :label="$t('fba.orderState')">
            <template v-slot="scope">
              <div v-for="(item, i) in orderStatusOptions" :key="i">
                <div v-if="scope.row.orderStatus == item.value">
                  {{ item.label }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="categoryFlag" align="center" :label="$t('fba.storage')">
            <template v-slot="scope">
              <div v-if="scope.row.categoryFlag == '0'">{{$t('common.no')}}</div>
              <div v-if="scope.row.categoryFlag == '1'">{{$t('common.yes')}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="goodsCount" :label="$t('orderList.orderList29')" align="center"></el-table-column>

          <!-- <el-table-column prop="waitingCount" align="center" :label="$t('fba.packingNumber')"></el-table-column> -->
          <!-- <el-table-column prop="canBoxCount" align="center" :label="$t('fba.canBoxCount')"></el-table-column> -->
          <!--          <el-table-column prop="badCount" align="center" :label="$t('fba.badToHandle')" min-width="100"></el-table-column>-->
          <!--          <el-table-column prop="exchangCount" align="center" :label="$t('fba.exchanging')"></el-table-column>-->
          <!--          <el-table-column prop="reissueCount" :label="$t('fba.reissuing')" align="center"></el-table-column>-->
          <el-table-column prop="refundCount" :label="$t('fba.returnNumber')" align="center"></el-table-column>
          <el-table-column prop="destroyCount" :label="$t('fba.destroyNumber')" align="center"></el-table-column>
          <el-table-column prop="netWeight" :label="$t('orderList.orderList130')" align="center">
            <template v-slot="scope">
              {{   (scope.row.netWeight * scope.row.containerGoodsCount).toFixed(3) }}
            </template>
          </el-table-column>
          <el-table-column prop="canApplyCount" :label="$t('fba.canApplyCount')" align="center"></el-table-column>
          <el-table-column width="180" align="center" :label="$t('fba.applyNumber')+'【'+'計 '+applyNumberTotal+' 件'+'】'" min-width="130">
            <template v-slot="scope">
              <el-input-number @change="changeGoodsCount(scope.row,$event)" :placeholder="$t('common.pleaseInput')" clearable
                v-model="scope.row.containerGoodsCount" :max="Number(scope.row.canApplyCount)" :min="1" size="small" style="width: 100px">
              </el-input-number>
            </template>
          </el-table-column>
          <el-table-column align="center" :label="$t('common.del')" width="90">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button type="primary" plain @click="delGooods(scope.row)" size="mini"> {{$t('common.del')}} </el-button>
              </div>
            </template>
          </el-table-column>

          <!--          <el-table-column-->
          <!--              prop="trackingNumberCn"-->
          <!--              label="国内运单号"-->
          <!--              min-width="150"-->
          <!--          ></el-table-column>-->
          <!--          <el-table-column-->
          <!--              prop="configCheckProjectArray"-->
          <!--              label="检品"-->
          <!--              min-width="175"-->
          <!--              align="center"-->
          <!--          >-->
          <!--            <template v-slot="scope">-->
          <!--                <span v-if="scope.row.configCheckProjectArray&&scope.row.configCheckProjectArray.length>0">-->
          <!--                  <span v-for="item in scope.row.configCheckProjectArray.split(',')" :key="item">-->
          <!--                    {{item | inspectionFilter}}-->
          <!--                  </span>-->
          <!--                </span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </el-table>
        <div class="tips">{{$t('addr.addr52')}}：{{applyNumberTotal}} {{$t('addr.addr50')}}：{{totalNetWeight}}</div>
        <div style="flex: none;">
          <el-form :model="ContainerOrder" :rules="rules" ref="ruleForm" label-position='left' class="demo-ruleForm">
            <el-row class="search-row" type="flex" justify="center">
              <el-col :span="7" class="display-row">
                <div class="query-title"><span class="col-red">*</span>{{$t('fba.sendAddress')}}:</div>
                <div class="flex1">
                  <el-form-item prop="ids">
                    <el-select v-model="ContainerOrder.ids" :placeholder="$t('common.pleaseSelect')" size="small" clearable style="width: 500px">
                      <el-option v-for="item in sendReceivingAddress" :key="item.id" :label="item.detailedAddresserInfo" :value="item.id"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="7" class="display-row">
                <div class="query-title"><span class="col-red">*</span>{{$t('fba.address')}}:</div>
                <div class="flex1">
                  <el-form-item prop="id">
                    <el-select v-model="ContainerOrder.id" :placeholder="$t('common.pleaseSelect')" size="small" clearable style="width: 500px">
                      <el-option v-for="item in ReceivingAddress" :key="item.id" :label="item.detailedAddresserInfo" :value="item.id"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row class="search-row" type="flex" justify="center">
              <el-col :span="7" class="display-row">
                <div class="query-title"><span class="col-red">*</span>{{$t('fba.line')}}:</div>
                <div class="flex1">
                  <el-form-item prop="route">
                    <el-select v-model="ContainerOrder.route" :placeholder="$t('common.pleaseSelect')" size="small" clearable style="width: 500px"
                      @change='lineChenge'>
                      <el-option v-for="item in routeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="7" class="display-row">
                <div class="query-title"><span class="col-red">*</span>{{$t('fba.logisticsCompany')}}:</div>
                <div class="flex1">
                  <el-form-item prop="logisticeCompany">
                    <el-select v-model="ContainerOrder.logisticeCompany" :placeholder="$t('common.pleaseSelect')" size="small" clearable style="width: 500px"
                      @change="logisticeChenge">
                      <el-option v-for="item in dropDownListEdit" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row class="search-row" type="flex" justify="center">
              <el-col :span="7" class="display-row">
                <div class="query-title">{{$t('common.remark')}}:</div>
                <div class="flex1">
                  <el-input :placeholder="$t('common.pleaseInput')" maxlength="200" clearable v-model="ContainerOrder.comments" size="small">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="7" class="display-row display-row-custom">

                <div class="query-title">{{$t('createOrder.createOrder117')}}:</div>
                <div class="flex1">
                  <my-upload size="mini" v-model="attachmentList" :limit="5" mode="array" :keyObject="{url:'url',name:'name'}" multiple listType="text"
                    class="upload-style-custom">
                    <el-button class="search-btn btn-blue">{{ $t('createOrder.createOrder117') }}</el-button>
                  </my-upload>
                  <!-- <el-upload class="editor-slide-upload" action=""
                            :on-remove="handleRemove" :before-upload="beforeUploadFile"  multiple :show-file-list="true" :limit="5" :on-exceed="handleExceed"
                            :file-list="attachmentList" :http-request="excelUploadRequest">
                    <el-button class="search-btn btn-blue">{{ $t('createOrder.createOrder117') }}</el-button>
                  </el-upload> -->
                </div>

              </el-col>
            </el-row>

            <el-row type="flex" align="middle">
              <el-col type="flex" justify="center" align="middle">
                <div>
                  <el-button class="form-btn btn-gray" @click="CancelSubm">{{$t('common.cancel')}}</el-button>
                  <el-button class="form-btn btn-blue" @click="SubmitSaveCheck('ruleForm')">{{$t('common.submit')}}</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!-- 搜索商品展示 -->
        <el-dialog :visible.sync="GoodsListVisible" width="90%" @close="GoodsListDialogClosed" :title="$t('fba.createPackList')">
          <table-con :showBreadCrumb="showBreadCrumb">
            <div slot="search">
              <el-row class="search-row">
                <el-col :span="isClientManage === '1' || isChildrenAll ? 6 : 8" class="display-row">
                  <div class="title-seach">{{$t('fba.orderNo')}}:</div>
                  <div class="flex1">
                    <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.id" size="small" @keyup.enter.native="searchList">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="isClientManage === '1' || isChildrenAll ? 6 : 8" class="display-row">
                  <div class="title-seach">{{$t('OrderDetail.OrderDetail55')}}:</div>
                  <div class="flex1">
                    <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.goodsNameCus" size="small" @keyup.enter.native="searchList">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="isClientManage === '1' || isChildrenAll ? 6 : 8" class="display-row">
                  <div class="title-seach">FNSKU:</div>
                  <div class="flex1">
                    <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.fnsku" size="small" @keyup.enter.native="searchList">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="6" class="display-row" v-if="isClientManage === '1'">
                  <div class="title-seach">{{ $t("cnumber.cnumber20") }}:</div>
                  <div class="flex1">
                    <ChildCode v-model="queryInfo.userId" @change="searchList" clearable></ChildCode>
                  </div>
                </el-col>
                <el-col :span="6" class="display-row" v-if="isChildrenAll">
                  <div class="title-seach">{{ $t("cnumber.cnumber20") }}:</div>
                  <div class="flex1">
                    <ChildCodeAll v-model="queryInfo.userId" @change="searchList" clearable></ChildCodeAll>
                  </div>
                </el-col>
                <el-col :span="isClientManage === '1' || isChildrenAll ? 6 : 8" style="margin-top: 10px;" class="display-row">
                  <div class="title-seach">
                    {{ $t("common.createStartDate") }}:
                  </div>
                  <div class="flex1">
                    <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                    :placeholder="$t('common.selectDate')">
                    </el-date-picker>
                  </div>
                </el-col>
                <el-col :span="isClientManage === '1' || isChildrenAll ? 6 : 8" style="margin-top: 10px;" class="display-row">
                  <div class="title-seach">{{ $t("common.createEndDate") }}:</div>
                  <div class="flex1">
                    <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                    :placeholder="$t('common.selectDate')">
                    </el-date-picker>
                  </div>
                </el-col>
                <el-col :span="isClientManage === '1' || isChildrenAll ? 6 : 8" style="margin-top: 10px;" class="display-row">
                  <div style="width: 160px" class="title-seach">FBA/YFF/ZOZO/RSL/ストッククルー:</div>
                  <el-select v-model="queryInfo.orderType" placeholder="FBA/YFF/ZOZO/RSL/ストッククルー" size="small" style="width: 180px !important;">
                    <el-option v-for="item in orderTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="isClientManage === '1' || isChildrenAll ? 6 : 8" style="margin-top: 10px;" class="display-row">
                  <div class="search-btn-container">
                    <el-button class="search-btn btn-blue" @click="searchList">{{$t('common.search')}}</el-button>
                    <el-button class="search-btn btn-gray" @click="queryInfoClear">{{$t('common.reset')}}</el-button>
                    <el-button type="primary" plain size="mini" @click="FBAContainerOrderExport">{{$t('FBAContainerOrder.FBAContainerOrder8')}}</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div slot="table">
              <el-table :data="GoodsList" border stripe style="width: 100%" @selection-change="handleSelectionChange"
                :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle">
                <el-table-column align="center" type="selection" :selectable='checkboxSelect' width="55"> </el-table-column>
                <el-table-column type="index" :label="$t('wzbg.wz6')" align="center" width="40"></el-table-column>
<!--                <el-table-column align="center" prop="userName" :label="$t('createOrder.createOrder102')" width="70"> </el-table-column>-->
                <el-table-column align="center" prop="clientManagerUserName" :label="$t('cnumber.cnumber30')" width="70"> </el-table-column>
                <el-table-column align="center" prop="id" :label="$t('fba.orderNo')" width="70"> </el-table-column>
                <el-table-column prop="goodsName" :label="$t('fba.goodsName')" min-width="200"></el-table-column>
                <el-table-column :label="$t('OrderDetail.OrderDetail54')" min-width="250" align="center" width="180">
                  <template slot-scope="scope">
                    <img :src="scope.row.pictureUrl" @click="imgclick(scope.row.pictureUrl,true)" width="180" height="320" class="head_pic" />
                  </template>
                </el-table-column>
                <el-table-column prop="orderType" align="center" label="FBA YFF/ZOZO/RSL/ストッククルー" width="90">
                  <template v-slot="scope">
                    <span v-if="scope.row.orderType == 0">FBA</span>
                    <span v-if="scope.row.orderType == 1">{{$t('filter.filter36')}}</span>
                    <span v-if="scope.row.orderType == 2">YFF</span>
                    <span v-if="scope.row.orderType == 3">ZOZO</span>
                    <span v-if="scope.row.orderType == 4">RSL</span>
                    <span v-if="scope.row.orderType == 5">ストッククルー</span>
                  </template>
                </el-table-column>
                <el-table-column prop="fnsku" label="FNSKU" align="center"></el-table-column>
                <el-table-column prop="goodsNameCus" :label="$t('OrderDetail.OrderDetail55')" align="center" width="200">
                  <template v-slot="scope">
                    <el-input type="textarea" placeholder="" v-model="scope.row.goodsNameCus" size="small" disabled>
                    </el-input>
                  </template>
                </el-table-column>
                <!--                <el-table-column prop="trackingNumberCn" :label="$t('fba.domesticWaybillNo')" width="90"></el-table-column>-->
                <el-table-column prop="orderStatus" align="center" :label="$t('fba.orderState')" width="90">
                  <template v-slot="scope">
                    <div v-for="(item, i) in orderStatusOptions" :key="i">
                      <div v-if="scope.row.orderStatus == item.value">
                        {{ item.label }}
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column prop="categoryFlag" align="center" :label="$t('fba.storage')" width="110">
                  <template v-slot="scope">
                    <!--<div v-if="scope.row.categoryFlag == '0'">{{$t('common.no')}}</div>-->
                    <!--<div v-if="scope.row.categoryFlag == '1'">{{$t('common.yes')}}</div>-->
                    <span v-if="
                      scope.row.warehouseStorageDays != null &&
                      scope.row.checkFinishTime != null
                    ">
                      <span v-if="scope.row.warehouseStorageDays >= 10">
                        {{ $t("orderList.orderList140") }}
                        {{ scope.row.warehouseStorageDays }}日
                      </span>
                      <span v-if="
                          scope.row.warehouseStorageDays < 10 &&
                          scope.row.warehouseStorageDays > 0
                        " style="color: orange">
                        {{ $t("orderList.orderList140") }}
                        {{ scope.row.warehouseStorageDays }}日
                      </span>
                      <span v-if="scope.row.warehouseStorageDays == 0" style="color: red">
                        {{ $t("orderList.orderList140") }}
                        {{ scope.row.warehouseStorageDays }}日
                      </span>
                       <span v-if="scope.row.warehouseStorageDays < 0" style="color: red">
                        {{ $t("orderList.orderList142") }}
                        {{ Math.abs(scope.row.warehouseStorageDays) }}日
                      </span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="goodsCount" :label="$t('orderList.orderList29')" align="center"></el-table-column>
                <!--                <el-table-column :label="$t('fba.simple')" min-width="150">-->
                <!--                  <template v-slot="scope">-->
                <!--                    <span v-if="scope.row.inspection&&scope.row.inspection.length>0">-->
                <!--                      <span v-for="item in scope.row.inspection.split(',')" :key="item">-->
                <!--                        {{item}}-->
                <!--                      </span>-->
                <!--                    </span>-->
                <!--                  </template>-->
                <!--                </el-table-column>-->
                <!-- <el-table-column prop="waitingCount" :label="$t('fba.packingNumber')" align="center" width="90"></el-table-column> -->
                <!--                <el-table-column prop="badCount" :label="$t('fba.badToHandle')" align="center" width="100"></el-table-column>-->
                <!--                <el-table-column prop="exchangCount" :label="$t('fba.exchanging')" align="center" width="70"></el-table-column>-->
                <!--                <el-table-column prop="reissueCount" :label="$t('fba.reissuing')" align="center" width="70"></el-table-column>-->
                <el-table-column prop="destroyCount" :label="$t('fba.destroyNumber')" align="center" width="90"></el-table-column>
                <el-table-column prop="refundCount" :label="$t('fba.returnNumber')" align="center" width="90"></el-table-column>
                <!-- <el-table-column prop="canBoxCount" :label="$t('fba.canBoxCount')" align="center" width="90"></el-table-column> -->
                <el-table-column prop="canApplyCount" :label="$t('fba.canApplyCount')" align="center" width="90">
                </el-table-column>
                <el-table-column prop="netWeight" :label="$t('orderList.orderList130')" align="center">
                  <template v-slot="scope">
                   {{scope.row.netWeight * scope.row.canApplyCount}}
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="GoodsList.pagenum"
                :page-sizes="[5, 10, 20, 50, 100]" :pager-count="5" :page-size="GoodsList.pagesize" layout="total, sizes, prev, pager, next, jumper"
                :total="total"></el-pagination>
              <!-- </div>  -->
              <div slot="footer" class="dialog-footer search-btn-container" style="padding: 12px 5px 0 20px">
                <el-button class="form-btn btn-gray" @click="CloseVisible">{{$t('common.cancel')}}</el-button>
                <el-button class="form-btn btn-blue" @click="SubmitVisible">{{$t('common.submit')}}</el-button>
              </div>
            </div>
          </table-con>
        </el-dialog>
      </div>
    </full-con>

    <!-- 提交时弹框提示 -->
    <!-- <el-dialog :title="$t('common.tip')" :visible.sync="SubmitTips" width="20%" @close="SubmitTipsClose">
      <p>{{$t('fba.submitAfterHandle')}}</p>
    </el-dialog> -->
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
  </div>
</template>
<script>
import t from "@/i18n/ja-JP"
import * as xlsx from 'xlsx'
import ChildCode from "@/components/ChildCode/index.vue";
import ChildCodeAll from "@/components/ChildCodeAll/index.vue";

export default {
  components: {ChildCode,ChildCodeAll},
  data () {
    return {
      isChildrenAll: false,
      isClientManage: this.$store.state.isClientManage,
      attachmentList: [],
      showBreadCrumb: '0',
      canReturn: '1',
      pageTitle: this.$t('fba.createPackList'),
      //订单状态
      orderStatusOptions: [],
      //所有的商品列表
      GoodsList: [],
      //条件(查询信息)
      queryInfo: [],
      //选中的商品列表T
      SelectedGoodsList: [],
      applyNumberTotal: 0,
      //临时的商品列表
      TemporaryList: [],
      //展示按钮
      GoodsListVisible: false,
      //提交弹框
      // SubmitTips: false,
      //收货地址
      ReceivingAddress: [],
      sendReceivingAddress: [],
      //线路
      routeList: [
        {
          value: '1',
          label: this.$t('FBAContainerOrder.FBAContainerOrder1')
        },
        {
          value: '2',
          label: this.$t('FBAContainerOrder.FBAContainerOrder2')
        }
      ],
      visible: false,
      imgurl: '',
      //物流公司的下拉地址
      dropDownList: [],
      dropDownListEdit: [],
      //新增的装箱单内容
      ContainerOrder: {
        ids: '',
        id: "",
        recipientName: "",
        logisticsCompanyId: '',
        zipCode: "",
        deliveryAddress: "",
        comments: "",
        listOrderJson: "",
        addressInfo: "",
        senderAddress: "",
        senderName: "",
        senderZipCode: "",
        route: "",
        logisticeCompany: "",
        legalNo: "",
        naccsAccount: "",
        companyName: "",
        email: "",
        attachment: "",
      },
      rules: {
        ids: [
          { required: true, message: this.$t('FBAContainerOrder.FBAContainerOrder3'), trigger: 'change' }
        ],
        id: [
          { required: true, message: this.$t('FBAContainerOrder.FBAContainerOrder4'), trigger: 'change' }
        ],
        route: [
          { required: true, message: this.$t('FBAContainerOrder.FBAContainerOrder5'), trigger: 'change' }
        ],
        logisticeCompany: [
          { required: true, message: this.$t('FBAContainerOrder.FBAContainerOrder6'), trigger: 'change' }
        ],
      },
      // senContainerOrder: {
      //   id:"",
      //   recipientName: "",
      //   zipCode: "",
      //   deliveryAddress: "",
      //   comments: "",
      //   listOrderJson: "",
      //   addressInfo:"",
      //   senderAddress:"",
      //   senderName:"",
      //   senderZipCode:""
      // },
      queryInfo: {
        userId: "",
        id: "",
        goodsNameCus: "",
        fnsku: "",
        orderStatus: "",
        trackingNumberCn: "",
        createTimeStart: "",
        createTimeEnd: "",
        orderType: "",
        pageSize: 10,
        pageNum: 1,
      },
      total: 0,
      orderTypeOptions:[
        {
          value:0,
          label:'FBA'
        },
        {
          value:1,
          label:t.filter.filter36
        },
        {
          value:2,
          label:'YFF'
        },
        {
          value:3,
          label:'ZOZO'
        },
        {
          value:4,
          label:'RSL'
        },
        {
          value:5,
          label:'ストッククルー'
        },
      ]
    }
  },
  watch: {
    SelectedGoodsList: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.applyNumberTotal = 0
          newVal.forEach(item => {
            this.applyNumberTotal += item.containerGoodsCount
          })
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    async getUserInfo() {
      const res = await this.$http.get("admin/info");
      if(res.data.data.clientRole.dataPermissions === '0'){
        this.isChildrenAll = true
      }else {
        this.isChildrenAll = false
      }
    },
    changeGoodsCount (row, e) {
      console.log(row, 'row')
      console.log(e, 'e')
      if (e) {
        this.SelectedGoodsList.forEach(item => {
          if (item.id === row.id) {
            item.containerGoodsCount = e
          }
          this.applyNumberTotal += item.containerGoodsCount
        })
      }
    },
    async excelUploadRequest (file) {
      let formdata = new FormData()
      formdata.append('file', file.file)
      const { data: res } = await this.$http.post('cmUser/message/uploadFile', formdata)
      if (res.code === 200) {
        let { fileName, filePath } = res.data
        this.attachmentList.push({ name: fileName, url: filePath, type: 0, customerDelete: 0, operatorDelete: 0 })
      }
    },
    handleRemove (file, fileList) {
      for (let i = 0; i < this.attachmentList.length; i++) {
        let attach = this.attachmentList[i]
        if (file.name == attach.name) {
          this.attachmentList.splice(i, 1)
        }
      }
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `${this.$t('createOrder.createOrder91')}，${this.$t('createOrder.createOrder92')} ${files.length} ${this.$t('createOrder.createOrder93')}，${this.$t('createOrder.createOrder94')} ${files.length + fileList.length
        } ${this.$t('createOrder.createOrder93')}`
      )
    },
    beforeUploadFile (file) {
      let fileType = ['.jpg', '.jpeg', '.png', '.gif', '.xls', '.xlsx', '.pdf', '.mp4', '.doc', '.docx', '.xlsm']
      const extension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      if (!fileType.includes(extension)) {
        this.$message.warning(this.$t('validate.fileFormat'))
        return false
      }
    },
    // 待装箱为0不可选中
    checkboxSelect (row) {
      if (row.waitingCount == 0) {
        return false
      } else {
        return true
      }
    },
    // 选择物流公司
    logisticeChenge (value) {
      this.ContainerOrder.logisticsCompanyId = this.dropDownListEdit.find(item => item.companyName === value).id
    },
    // 选择线路
    lineChenge (e) {
      this.getDropDownForLineList(e)
      this.ContainerOrder.logisticeCompany = ''
      this.ContainerOrder.logisticsCompanyId = ''
    },
    queryInfoClear () {
      this.queryInfo = {
        id: "",
        goodsName: "",
        fnsku: "",
        orderStatus: "",
        trackingNumberCn: "",
        orderType: "",
        pageSize: 10,
        pageNum: 1,
      }
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize
      this.getGoodsList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage
      this.getGoodsList()
    },
    newBuiltGoods () {
      this.GoodsListVisible = true
      this.getGoodsList()
    },
    GoodsListDialogClosed () {
      this.GoodsListVisible = false
      this.TemporaryList = []
    },
    imgclick (url, visible) {
      this.visible = true
      this.imgurl = url
    },
    //关闭
    CloseVisible () {
      this.GoodsListVisible = false
      this.TemporaryList = []
    },
    // SubmitTipsClose() {
    //   this.SubmitTips = false;
    // },
    //提交搜索的商品
    SubmitVisible () {
      this.TemporaryList.forEach(p => {
        this.$set(p, 'containerGoodsCount', p.canApplyCount)
      })
      this.SelectedGoodsList.forEach((item) => {
        this.TemporaryList.forEach((o) => {
          if (o.id == item.id) {
            this.TemporaryList.splice(this.TemporaryList.indexOf(o), 1)
            // item.containerGoodsCount = o.canApplyCount
          }
        })
      })
      this.SelectedGoodsList = this.SelectedGoodsList.concat(
        this.TemporaryList
      )
      console.log(this.SelectedGoodsList,'this.SelectedGoodsList');
      this.TemporaryList = []
      this.GoodsListVisible = false
    },
    handleFileSelect(event) {
      const file = event.raw;
      const reader = new FileReader();
      // 处理文件内容
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = xlsx.read(data, { type: 'array' });

        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = xlsx.utils.sheet_to_json(worksheet, { header: 1 });
        // 提取文件内容
        jsonData.slice(1).forEach((row,index) => {
          console.log(row[12])
          let rowData = {
            index: index,
            id: row[0],
            goodsName: row[1],
            pictureUrl: row[2],
            orderType: this.orderTypeOptions.find(item=>item.label === row[3])?.value,
            fnsku: row[4],
            goodsNameCus: row[5],
            orderStatus: this.orderStatusOptions.find(item=>item.jpLabel === row[6])?.value,
            categoryFlag: row[7] == 'NO'?'0':'1',
            goodsCount: row[8],
            destroyCount: row[9],
            refundCount: row[10],
            canApplyCount: row[11],
            netWeight: row[12],
            totalNetWeight:1
          }
          console.log(rowData)
          this.TemporaryList.push(rowData)
        })
        this.TemporaryList.forEach(p => {
          this.$set(p, 'containerGoodsCount', p.canApplyCount)
        })
        this.SelectedGoodsList.forEach((item) => {
          this.TemporaryList.forEach((o) => {
            if (o.id == item.id) {
              this.TemporaryList.splice(this.TemporaryList.indexOf(o), 1)
              // item.containerGoodsCount = o.canApplyCount
            }
          })
        })
        this.SelectedGoodsList = this.SelectedGoodsList.concat(
            this.TemporaryList
        )
      };
      // 读取文件内容
      reader.readAsArrayBuffer(file);
    },

    //查询商品列表
    searchList () {
      this.queryInfo.pageNum = 1
      this.getGoodsList()
    },
    //复选框选中插入临时表
    handleSelectionChange (val) {
      this.TemporaryList = val
    },
    //删除商品
    delGooods (row) {
      this.SelectedGoodsList.splice(this.SelectedGoodsList.indexOf(row), 1)
    },
    //从后台获取商品列表
    async getGoodsList () {
      const { data: res } = await this.$http.post(
        "order/GoodsList",
        this.queryInfo
      )
      this.GoodsList = res.data.list
      this.total = res.data.total
      console.log(this.GoodsList)
    },
    FBAContainerOrderExport () {
      this.$http({
        url: "order/FBAContainerOrderExport",
        method: "POST",
        data: {...this.queryInfo},
        responseType: "blob", // 表明返回服务器返回的数据类型
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement("a")
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
        link.style.display = "none"
        //设置连接
        link.href = URL.createObjectURL(blob)
        link.download = `新規梱包伝票.xls`
        document.body.appendChild(link)
        //模拟点击事件
        link.click()
      })
    },

    //从后台获取收货地址
    async getReceivingAddress () {
      const { data: res } = await this.$http.post(
        "container/obtainReceivingAddress"
      )
      this.ReceivingAddress = res.data
    },
    //从后台获取收货地址
    async getSendAddress () {
      const { data: res } = await this.$http.post(
        "container/sendReceivingAddress"
      )
      this.sendReceivingAddress = res.data
    },
    //选择商品
    choiceGoods (row) {
      this.SelectedGoodsList.unshift(row)
    },
    SubmitSaveCheck (formName) {
      let state = false
      this.SelectedGoodsList.forEach((item) => {
        if (item.containerGoodsCount == undefined) {
          state = true
        }
      })
      if (
        JSON.stringify(this.SelectedGoodsList) == "[]"
        // ||
        // this.ContainerOrder.id == "" ||
        // this.ContainerOrder.id == undefined ||
        // state
      ) {
        this.$message.error(this.$t('FBAContainerOrder.FBAContainerOrder7'))
        // this.SubmitTips = true;
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.SubmitSave()
          } else {
            return false
          }
        })
      }
    },
    checkOrderGroup() {
      let orderIdList = this.SelectedGoodsList.map(item => Number(item.id));
      return this.$modalDialog(
          () => import("../orders/orderGroupDialog/index.vue"),
          { orderIdList: orderIdList }
      ).then(
          (orderIdArr) => {
            return orderIdArr
          },
          (orderIdArr) => {
            return orderIdArr;
          }
      )
    },
    //提交到后台
    async SubmitSave () {

      let orderIdArr = await this.checkOrderGroup();
      if (orderIdArr.length >0) {
        console.log(orderIdArr.length)
        const idSet = new Set(orderIdArr);
        this.SelectedGoodsList = this.SelectedGoodsList.filter(goods => !idSet.has(goods.id));
        return;
      }

      if (JSON.stringify(this.SelectedGoodsList) == "[]") {
        return  this.$message.error(this.$t('FBAContainerOrder.FBAContainerOrder7'))
      }

      if (this.attachmentList.length > 0) {
        this.ContainerOrder.attachment = JSON.stringify(this.attachmentList)
      } else {
        this.ContainerOrder.attachment = ''
      }

      let address
      let senAddress
      this.$set(
        this.ContainerOrder,
        "listOrderJson",
        JSON.stringify(this.SelectedGoodsList)
      )
      this.ReceivingAddress.forEach(o => {
        if (this.ContainerOrder.id == o.id) {
          address = o
        }
      })
      this.sendReceivingAddress.forEach(o => {
        if (this.ContainerOrder.ids == o.id) {
          senAddress = o
        }
      })
      this.$set(
        this.ContainerOrder,
        "recipientName",
        address.receiverName
      )
      this.$set(
        this.ContainerOrder,
        "zipCode",
        address.postcode
      )
      this.$set(
        this.ContainerOrder,
        "deliveryPhone",
        address.receiverPhone
      )
      this.$set(
        this.ContainerOrder,
        "sendArea",
        address.provence + address.city + address.area
      )
      this.$set(
        this.ContainerOrder,
        "deliveryAddress",
        address.addressInfo
      )
      this.$set(
        this.ContainerOrder,
        "senderName",
        senAddress.receiverName
      )
      this.$set(
        this.ContainerOrder,
        "senderZipCode",
        senAddress.postcode
      )
      this.$set(
        this.ContainerOrder,
        "senderAddress",
        senAddress.addressInfo
      )
      this.$set(
        this.ContainerOrder,
        "senderPhone",
        senAddress.receiverPhone
      )
      this.$set(
        this.ContainerOrder,
        "addresserArea",
        senAddress.provence + senAddress.city + senAddress.area
      )
      this.$set(
        this.ContainerOrder,
        "legalNo",
        senAddress.legalNo
      )
      this.$set(
        this.ContainerOrder,
        "naccsAccount",
        senAddress.naccsAccount
      )
      this.$set(
        this.ContainerOrder,
        "companyName",
        senAddress.companyName
      )
      this.$set(
        this.ContainerOrder,
        "email",
        senAddress.email
      )
      const { data: res } = await this.$http.post(
        "container/addContainerOrder",
        this.ContainerOrder
      )
      console.log(res,678)
      if(res.code !== 200) {
        return this.$message.error(res.message)
      }
      this.$router.push({
        name: "FBA",
      })
    },
    //取消并返沪FBA主页
    CancelSubm () {
      this.$router.push({
        name: "FBA",
      })
    },
    async getDropDownForLineList (line) {
      if (line) {
        const { data: res } = await this.$http.get("cms/logisticsCompany/getDropDownForLineList/" + line + "?username="+window.sessionStorage.getItem('username'))
        this.dropDownListEdit = res.data
      } else {
        this.dropDownListEdit = []
      }

    }
  },
  created () {
    this.orderStatusOptions = [
      {
        value: "1",
        label: this.$t('filter.filter1'),
        jpLabel:t.filter.filter1
      },
      {
        value: "2",
        label: this.$t('filter.filter2'),
        jpLabel:t.filter.filter2
      },
      {
        value: "0",
        label: this.$t('filter.filter3'),
        jpLabel:t.filter.filter3
      },
      {
        value: "4",
        label: this.$t('filter.filter4'),
        jpLabel:t.filter.filter4
      },
      {
        value: "8",
        label: this.$t('filter.filter5'),
        jpLabel:t.filter.filter5
      },
      {
        value: "12",
        label: this.$t('filter.filter6'),
        jpLabel:t.filter.filter6
      }, {
        value: '16',
        label: this.$t('filter.filter7'),
        jpLabel:t.filter.filter7
      }, {
        value: '20',
        label: this.$t('filter.filter8'),
        jpLabel:t.filter.filter8
      }, {
        value: '24',
        label: this.$t('filter.filter9'),
        jpLabel:t.filter.filter9
      }, {
        value: '26',
        label: this.$t('filter.filter10'),
        jpLabel:t.filter.filter10
      }, {
        value: '28',
        label: this.$t('filter.filter11'),
        jpLabel:t.filter.filter11
      }, {
        value: '32',
        label: this.$t('filter.filter12'),
        jpLabel:t.filter.filter12
      }, {
        value: '36',
        label: this.$t('filter.filter13'),
        jpLabel:t.filter.filter13
      }, {
        value: '40',
        label: this.$t('filter.filter14'),
        jpLabel:t.filter.filter14
      }, {
        value: '44',
        label: this.$t('filter.filter15'),
        jpLabel:t.filter.filter15
      }, {
        value: '48',
        label: this.$t('filter.filter16'),
        jpLabel:t.filter.filter16
      }, {
        value: '52',
        label: this.$t('filter.filter17'),
        jpLabel:t.filter.filter17
      }, {
        value: '56',
        label: this.$t('filter.filter18'),
        jpLabel:t.filter.filter18
      }, {
        value: '60',
        label: this.$t('filter.filter19'),
        jpLabel:t.filter.filter19
      }, {
        value: '64',
        label: this.$t('filter.filter20'),
        jpLabel:t.filter.filter20
      }, {
        value: '68',
        label: this.$t('filter.filter21'),
        jpLabel:t.filter.filter21
      }, {
        value: '72',
        label: this.$t('filter.filter22'),
        jpLabel:t.filter.filter22
      }, {
        value: '76',
        label: this.$t('filter.filter23'),
        jpLabel:t.filter.filter23
      }, {
        value: '80',
        label: this.$t('filter.filter24'),
        jpLabel:t.filter.filter24
      }, {
        value: '82',
        label: this.$t('filter.filter25'),
        jpLabel:t.filter.filter25
      }, {
        value: '83',
        label: this.$t('filter.filter26'),
        jpLabel:t.filter.filter26
      }, {
        value: '84',
        label: this.$t('filter.filter27'),
        jpLabel:t.filter.filter27
      }, {
        value: '88',
        label: this.$t('filter.filter28'),
        jpLabel:t.filter.filter28
      }, {
        value: '89',
        label: this.$t('filter.filter29'),
        jpLabel:t.filter.filter29
      }
      // {
      //   value: "0",
      //   label: this.$t('fba.packing'),
      // },
      // {
      //   value: "1",
      //   label: this.$t('fba.toPay'),
      // },
      // {
      //   value: "2",
      //   label: this.$t('fba.toUploadInvoice'),
      // },
      // {
      //   value: "3",
      //   label: this.$t('fba.toSend'),
      // },
      // {
      //   value: "4",
      //   label: this.$t('fba.sent'),
      // },
      // {
      //   value: "5",
      //   label: this.$t('fba.cancelled'),
      // }, {
      //   value: '6',
      //   label: this.$t('fba.toPack'),
      // }
    ]
    this.getReceivingAddress()
    this.getSendAddress()
  },
  computed: {
    totalNetWeight () {
      let num = 0
      this.SelectedGoodsList.forEach(item => {
        if (item.totalNetWeight) {
          let number = Number((item.netWeight * item.containerGoodsCount))
          num += number
        }
      })
      return num.toFixed(3)
    }
  }
};
</script>

<style lang="less" scoped>
.order-detail-container {
  background: #fff;
  padding: 20px;
}
ul,
li {
  list-style: none;
}
.table-title {
  padding: 5px 0;
  text-align: center;
  background: #f1f2f6;
}
.table-content {
  border-right: 1px solid #e5e9f8;
}
.table-content .content .el-col {
  height: 35px;
  line-height: 30px;
  padding: 0 2px;
  border-left: 1px solid #e5e9f8;
  border-bottom: 1px solid #e5e9f8;
  text-align: center;
  // white-space:nowrap;
  // text-overflow:ellipsis;
  //overflow:auto;
}
.el-form-item {
  margin-bottom: 0 !important;
}
/deep/.el-form-item__content {
  line-height: 30px !important;
}
.el-container /deep/ .el-main {
  overflow: auto !important;
}
// .table-content .content{
//   padding-bottom: 10px;
// }
/deep/ .create-fba-content .el-dialog {
  // height: 100%;
  // overflow: auto;
  // width: 100%;
  // margin-top: 10px !important;
}
/deep/.create-fba-content .el-dialog__wrapper {
  // position: absolute;
}
/deep/.create-fba-content .el-dialog__body {
  padding: 10px;
}

.query-title-min {
  /* padding-right: 10px; */
  height: 30px;
  line-height: 30px;
  width: 80px;
  padding: 0 10px 0 10px;
  text-align: right;
}

/deep/.create-fba-content .table-container {
  margin-top: 0;
}
/deep/.create-fba-content .search-container {
  padding: 0;
}
.title-seach {
  padding: 6px 12px;
}
.demo-ruleForm {
  .search-row {
    margin-bottom: 15px;
  }
}
.col-red {
  color: red;
}
/deep/ .el-textarea__inner {
  color: #606266 !important;
}
.tips {
  margin: 10px 0px;
  padding-left: 50px;
  text-align: right;
}
.fba-container-order /deep/ .full-container {
  height: 100%;
  overflow: hidden;
}
.upload-style-custom {
  text-align: left;
  width: 100%;
  overflow: hidden;
}
.display-row-custom /deep/ .query-title {
  flex: none;
}
.display-row-custom /deep/ .flex1 {
  flex: 1;
  overflow: hidden;
}
.upload-style-custom /deep/ .my-upload-text-mini {
  width: 100%;
  overflow: hidden;
}
.upload-style-custom /deep/ .el-upload-list__item-name {
  padding-right: 30px;
}
</style>
